/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import { IMandsSiteIssuesPageData } from './mands-site-issues-page.data';
import { IMandsSiteIssuesPageProps } from './mands-site-issues-page.props.autogenerated';

/**
 *
 * MandsSiteIssuesPage component
 * @extends {React.PureComponent<IMandsSiteIssuesPageProps<IMandsSiteIssuesPageData>>}
 */
export default class MandsSiteIssuesPage extends React.PureComponent<IMandsSiteIssuesPageProps<IMandsSiteIssuesPageData>> {
    public render(): JSX.Element {
        return (
            <div className='row'>
                <div className='error-wrap'>
                    <div className='cont-box'>
                        <h2>Please bear with us</h2>
                        <p>Sorry you can&apos;t shop with us right now. We&apos;re working hard to be back online as soon as possible.</p>
                    </div>
                    <div className='img-box'>
                        <img
                            src='https://images-eu-prod.cms.commerce.dynamics.com/cms/api/scwrkbhfhd/imageFileData/MD1BXT'
                            alt='site issue'
                        />
                    </div>
                    <div className='img-box-mobile'>
                        <img
                            src='https://images-eu-prod.cms.commerce.dynamics.com/cms/api/scwrkbhfhd/imageFileData/MD1ziL'
                            alt='site issue'
                        />
                    </div>
                </div>
            </div>
        );
    }
}
